module.exports = __webpack_public_path__ + "assets/img/camera@1,5x.b3b0383e.svg";